import axios from '../axios';
// import router from '@/router/index';

export default {
  namespaced: true,
  state: () => ({}),
  actions: {
    async list(_, payload) {
      try {
        const response = await axios.get(`/activities?term=${payload.term}&page=${payload.page}`);
        return response.data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get(_, id) {
      try {
        const { data } = await axios.get(`/activities/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async edit(_, id) {
      try {
        const { data } = await axios.get(`/activities/${id}/edit`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get_types({ commit }) {
      try {
        const response = await axios.get(`/activities/activities_type`);
        commit('SET_NEWS_TYPES', response.data);
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async store(_, form_data) {
      try {
        const { data } = await axios.post(`/activities`, form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async update(_, form_data) {
      try {
        const { data } = await axios.post(`/activities/${form_data.get('id')}`, form_data);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async delete(_, id) {
      try {
        const { data } = await axios.delete(`/activities/${id}`);
        return data;
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    },
    async get_form_groups({ commit }) {
      try {
        const { data } = await axios.get(`/activities/form_groups`);
        commit('SET_FORM_TYPES', data);
      } catch(error) {
        const { response } = error;
        
        if(response) {
          throw(response.data);
        } else {
          throw({ message: 'เซิฟเวอร์มีปัญหาในขณะนี้ กรุณาลองใหม่ภายหลัง' });
        }
      }
    }
  },
  mutations: {
    SET_FORM_TYPES(state, data) { state.form_groups = data }
  }
    
}